import { downloadInfoSchema as N } from "../../deserializes/yup/download.js";
import s from "../../../temp-lib/config/index.js";
import { AssetType as J } from "../../../temp-lib/constants/url.js";
import { useLanguageContext as O } from "../../../temp-lib/contexts/language/LanguageContext.js";
import { usePreloadContext as F } from "../../../temp-lib/contexts/share/PreloadContext.js";
import M from "../../../temp-lib/hooks/generic/useApeironPathMaker.js";
import u from "../../../temp-lib/hooks/json/useFetchJson.js";
import * as a from "ramda";
import { useState as A, useMemo as C, useCallback as E, useEffect as S } from "react";
const y = () => {
  const [d, p] = A(null), { preloadValue: n } = F(), { language: h } = O(), { makePath: c } = M(), e = C(
    () => c(J.Json, s.JSON_FILE_NAME.DOWNLOAD),
    [c]
  ), { fetchJson: m } = u({ url: e }), { fetchJson: r } = u({
    url: s.JSON_FILE_NAME.DOWNLOAD_CONFIG
  }), f = E(async () => {
    const D = async () => Promise.all([m(), r()]), [t, g] = await n(e, D), o = (l) => N.cast(l, {
      context: {
        data: l,
        info: g
      }
    }), i = {
      battleDemo: a.map(o, (t == null ? void 0 : t.battleDemo) || []),
      foonieMagus: a.map(o, (t == null ? void 0 : t.battleDemo) || []),
      login: a.map(o, (t == null ? void 0 : t.login) || []),
      officialSite: a.map(o, (t == null ? void 0 : t.officialSite) || [])
    };
    return p(i), i;
  }, [r, m, n, e]);
  return S(() => {
    f();
  }, [h]), {
    data: d,
    fetchJson: f
  };
};
export {
  y as default
};
//# sourceMappingURL=useFetchDownloadMapJson.js.map
